<template>
  <div class="min-h-screen font-inter mt-6">
    <main class="w-full">
      <div
        class="w-full h-auto min-h-screen rounded-t-[20px] dark:bg-background"
      >
        <div class="md:flex gap-8 px-4 md:px-6">
          <BackButton />
          <div class="flex-1 md:px-0 py-2 md:pr-9">
            <AIAssessmentComponent />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import AIAssessmentComponent from "@/components/learning-goals/AIAssessmentComponent.vue";
import BackButton from "@/components/BackButton.vue";

export default {
  name: "AIAssessment",
  components: {
    AIAssessmentComponent,
    BackButton,
  },

  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped></style>
